import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getDosageList } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
const UseFetchDosageList = (page, pageSize, q, type) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["getDosageList", page, pageSize, q, type],
        queryFn: () => getDosageList(page, pageSize, q, type),
        enabled: !!page || !!pageSize || !!type,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchDosageList;
